
import { useLocation } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
import { useAdminStatus } from "@/hooks/useAdminStatus";
import { MobileNavBottom } from "@/components/navbar/MobileNavBottom";
import { UserDropdownMenu } from "@/components/navbar/UserDropdownMenu";
import { AuthButtons } from "@/components/navbar/AuthButtons";
import { NavbarLogo } from "@/components/navbar/NavbarLogo";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BookOpen } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";
import { Capacitor } from '@capacitor/core';

export default function Navbar() {
  const { user, isAdmin } = useAdminStatus();
  const isMobile = useIsMobile();
  const location = useLocation();
  const { t } = useTranslation();
  
  // Detect if running in iOS
  const isIOS = Capacitor.getPlatform() === 'ios';
  
  // Only hide the logo container on mobile for these specific pages
  const hideLogoContainer = isMobile && (
    location.pathname === '/inventory' || 
    location.pathname === '/profile' || 
    location.pathname === '/settings' ||
    location.pathname === '/develop'
  );

  return (
    <nav className="border-b">
      {!hideLogoContainer && (
        <div className={cn(
          "container flex h-16 items-center",
          isMobile ? "justify-between px-3" : "justify-between"
        )}>
          <div className="flex items-center gap-4">
            <NavbarLogo isMobile={isMobile} />
            
            {!isMobile && (
              <Link to="/resources">
                <Button variant="ghost" className="flex items-center gap-2">
                  <BookOpen size={16} />
                  {t('resources')}
                </Button>
              </Link>
            )}
          </div>

          {!isMobile && (
            user ? <UserDropdownMenu user={user} isAdmin={isAdmin} /> : <AuthButtons />
          )}
        </div>
      )}
      {isMobile && <MobileNavBottom isAdmin={isAdmin} user={user} />}
    </nav>
  );
}
